import { createContext } from "react";

export enum ThemeEnum {
  light = "light",
  dark = "dark",
}

export interface ThemeContextValue {
  theme: ThemeEnum;
}

const ThemeContext = createContext<ThemeContextValue>({
  theme: ThemeEnum.light,
});

const ThemeProvider = ({
  children,
  theme,
}: {
  children: React.ReactNode;
  theme: ThemeEnum;
}) => {
  return (
    <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
  );
};

export { ThemeContext, ThemeProvider };
